import {
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  LocationStrategy,
  PathLocationStrategy,
  PercentPipe,
  registerLocaleData,
} from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  PreloadAllModules,
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { provideIonicAngular } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StoreModule } from '@ngrx/store';
import { provideTranslateService, TranslateLoader, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { CookieService } from 'ngx-cookie-service';
import { provideMarkdown } from 'ngx-markdown';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { PRIMEUI_LICENSE_KEY } from 'src/environments/primeng';
import APP_ROUTES from './app.routes';
import { appStoreDynamicFormReducer } from './components/dynamic-form/store/store.dynamic-form.reducer';
import { MultiTranslateRootLoader } from './core/services/multi-translate-root.loader';
import { RestInterceptorService } from './core/services/rest-interceptor.service';
import { AppStorageService } from './core/utils/app.storage.service';
import { appStoreAdminCampaignReducer } from './pages/admin/campaign/store/store.admin-campaign.reducer';
import { appStoreFiltersReducer } from './store/filters/store.filters.reducer';
import { appStoreGlobalReducer } from './store/global/store.global.reducer';
import { appStoreScreenReducer } from './store/screen/store.screen.reducer';
import { appStoreSettingsReducer } from './store/settings/store.settings.reducer';

registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideIonicAngular(),
    // TODO: Test and remove...
    provideHttpClient(withFetch(), withXhr(), withInterceptorsFromDi()),
    provideTranslateService({
      fallbackLang: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: (storage: AppStorageService) => new MultiTranslateRootLoader(storage),
        deps: [AppStorageService],
      },
    }),
    provideMarkdown(),
    importProvidersFrom(
      IonicStorageModule.forRoot(),
      StoreModule.forRoot(
        {
          settings: appStoreSettingsReducer,
          filters: appStoreFiltersReducer,
          global: appStoreGlobalReducer,
          screen: appStoreScreenReducer,

          adminCampaign: appStoreAdminCampaignReducer,

          dynamicForm: appStoreDynamicFormReducer,
        },
        {
          runtimeChecks: {
            strictStateImmutability: false,
            strictActionImmutability: false,
          },
        },
      ),
    ),

    // TODO: Test and remove...
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      license: PRIMEUI_LICENSE_KEY,
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: palette('#FF5722'),
          },
        }),
        options: {
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng, p360_custom, utilities, p360_overrides',
          },
        },
      },
      overlayAppendTo: 'body',
    }),

    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    PercentPipe,
    TranslatePipe,

    CookieService,
    ConfirmationService,
    MessageService,
    TranslateService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestInterceptorService,
      multi: true,
    },
    Diagnostic,

    provideRouter(
      APP_ROUTES,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withEnabledBlockingInitialNavigation(),
    ),
  ],
};
